<script setup>
import DropdownMenuItem from '@/components/shared/dropdown/DropdownMenuItem.vue'

//Emits and props
defineEmits([
  'toggle-pinned',
  'toggle-unread',
  'toggle-paused',
  'toggle-archived',
  'manage',
])
defineProps({
  isPinned: {
    type: Boolean,
    default: false,
  },
  isUnread: {
    type: Boolean,
    default: false,
  },
  isPaused: {
    type: Boolean,
    default: false,
  },
  canManage: {
    type: Boolean,
    default: false,
  },
  canTogglePinned: {
    type: Boolean,
    default: false,
  },
  canToggleUnread: {
    type: Boolean,
    default: false,
  },
  canToggleArchived: {
    type: Boolean,
    default: false,
  },
  canTogglePaused: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <DropdownMenuItem
    v-if="canManage"
    icon="settings"
    label="Manage enrollment"
    @click="$emit('manage')"
  />
  <DropdownMenuItem
    v-if="canTogglePinned"
    :label="isPinned ? 'Unpin' : 'Pin'"
    @click="$emit('toggle-pinned')"
  />
  <DropdownMenuItem
    v-if="canToggleUnread && !isUnread"
    label="Mark as unread"
    icon="mark_email_unread"
    @click="$emit('toggle-unread')"
  />
  <DropdownMenuItem
    v-if="canToggleArchived && !isArchived"
    label="Archive"
    @click="$emit('toggle-archived')"
  />
  <DropdownMenuItem
    v-if="canTogglePaused"
    :label="isPaused ? 'Resume' : 'Pause'"
    :icon="isPaused ? 'play_arrow' : 'pause'"
    @click="$emit('toggle-paused')"
  />
</template>
